
import * as React from "react";

interface Props {
  height?: number;
  width?: number;
  checked?: boolean;
  disabled?: boolean;
}

const Checkbox = ({ height = 16, width = 16, checked = false, disabled = false, ...props }: Props) => (
  <svg
    fill="#000000"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    id="check-mark-square"
    data-name="Flat Line"
    xmlns="http://www.w3.org/2000/svg"
    className="icon flat-line"
    {...props}
  >
    <rect
      id="secondary"
      x={3}
      y={3}
      width={18}
      height={18}
      rx={1}
      style={{
        fill: disabled ? "#d9d9d9" : (checked ? "#1180e8" : "#ffffff"),
        strokeWidth: 2,
      }}
    />
    <polyline
      id="primary"
      points="16 9.5 11 14.5 8 11.5"
      style={{
        fill: "none",
        stroke: checked && !disabled ? "#1180e8" : (disabled ? "#888888" : " #000"),
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        display: checked ? "inline" : "none",
      }}
    />
    <rect
      id="primary-2"
      data-name="primary"
      x={3}
      y={3}
      width={18}
      height={18}
      rx={1}
      style={{
        fill: "none",
        stroke: checked && !disabled ? "#1180e8" : (disabled ? "#888888" : " #000"),
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
      }}
    />
  </svg>
);
export default Checkbox;
